(function (angular) {
	'use strict';
	angular.module('PinMeTo.services').factory('pmtPageTitleService', PageTitleService);

	PageTitleService.$inject = ['$window', '$timeout', 'auth'];
	function PageTitleService($window, $timeout, auth) {
		var pageTitleService = {};
		pageTitleService.setPage = function (pageName) {
			$timeout(function () {
				const title =
					auth.user && auth.user.selectedSite
						? auth.user.selectedSite.displayName + ' | ' + pageName
						: '';
				$window.document.title = title;
			});
		};
		return pageTitleService;
	}
})(window.angular);
